<template>
  <div class="card">
    <div class="card-title border-bottom p-3 mb-0 header-title">{{$t('common.upload_resume.steps.step2.title')}}</div>
    <div class="card-body">
      <div class="alert alert-danger" v-if="errorMessage">
        {{errorMessage}}
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="">{{$t('common.upload_resume.steps.step2.first_name.label')}}<span style="font-size:8pt"> (required)</span></label>
          <input 
            required
            type="text" 
            class="form-control"
            :placeholder="$t('common.upload_resume.steps.step2.first_name.placeholder')"
            v-model="model.first_name"
          >
        </div>
        <div class="form-group col-md-6">
          <label for="">{{$t('common.upload_resume.steps.step2.last_name.label')}}<span style="font-size:8pt"> (required)</span></label>
          <input 
            required
            type="text" 
            class="form-control"
            :placeholder="$t('common.upload_resume.steps.step2.last_name.label')"
            v-model="model.last_name"
          >
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="">{{$t('common.upload_resume.steps.step2.jp_first_name.label')}}</label>
          <input 
            type="text" 
            class="form-control"
            :placeholder="$t('common.upload_resume.steps.step2.jp_first_name.placeholder')"
            v-model="model.jp_first_name"
          >
        </div>
        <div class="form-group col-md-6">
          <label for="">{{$t('common.upload_resume.steps.step2.jp_last_name.label')}}</label>
          <input 
            type="text" 
            class="form-control"
            :placeholder="$t('common.upload_resume.steps.step2.jp_last_name.label')"
            v-model="model.jp_last_name"
          >
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <DropDown 
            :label="$t('common.upload_resume.steps.step2.gender.label') + ' (required)'"
            :name.sync="model.gender"
            v-model="model.gender"
            :options="gender_options"
            class="row col-md-6"
            required
          />
          <div class="form-group">
            <label for="">{{$t('common.upload_resume.steps.step2.summary.label')}}</label>
            <textarea 
              class="form-control"
              :placeholder="$t('common.upload_resume.steps.step2.summary.placeholder')"
              v-model="model.summary"
              rows="10"
            >
            </textarea>
          </div>

          <div class="form-group">
            <label for="">{{$t('common.upload_resume.steps.step2.country.label')}}<span style="font-size:8pt"> (required)</span></label>
            <input 
              type="text" 
              class="form-control"
              :placeholder="$t('common.upload_resume.steps.step2.country.placeholder')"
              v-model="model.country"
              required
            >
          </div>
          <div class="form-group">
            <label for="">{{$t('common.upload_resume.steps.step2.city.placeholder')}}<span style="font-size:8pt"> (required)</span></label>
            <input 
              type="text" 
              class="form-control"
              :placeholder="$t('common.upload_resume.steps.step2.city.label')"
              v-model="model.city"
              required
            >
          </div>

          <!-- <DropDown 
            label="Industry"
            :name.sync="model.industry"
            :options="industry_options"
          /> -->

        </div>
      </div>
      <hr>
      <h5>{{$t('common.upload_resume.steps.step2.contact_information')}}</h5>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="">{{$t('common.upload_resume.steps.step2.email.label')}}<span style="font-size:8pt"> (required)</span></label>
            <input 
              type="text" 
              :placeholder="$t('common.upload_resume.steps.step2.email.placeholder')"
              v-model="model.email"
              class="form-control required"
              required
            >
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="">{{$t('common.upload_resume.steps.step2.contact_no.label')}}</label>
              <input 
                type="text" 
                class="form-control"
                v-model="model.contact_no"
                :placeholder="$t('common.upload_resume.steps.step2.contact_no.placeholder')"
              >
            </div>

            <DropDown 
              label="Type"
              :name.sync="model.contact_type"
              v-model="model.contact_type"
              :options="contact_types_option"
              class="col-md-6"
            />
          </div>
          <div class="form-group">
            <label for="">{{$t('common.upload_resume.steps.step2.date_of_birth.label')}}</label>
            <flat-pickr
              v-model="model.date_of_birth"
              class="form-control"
              :placeholder="$t('common.upload_resume.steps.step2.date_of_birth.placeholder')"
            ></flat-pickr>
          </div>

          <b-form-group id="fileInput" class="dragdrop" v-if="!model.success">
            <b-form-file
            multiple
            accept=".docx, .pdf, .doc"
            v-model="files" 
            :placeholder="$t('common.upload_resume.steps.step1.multiple_drag_title')"></b-form-file>
          </b-form-group>

          <div class="alert alert-success text-center" v-if="model.success">
            Successfully Uploaded!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions } from 'vuex'
import DropDown from '@components/form/dropdown.vue'
import NProgress from 'nprogress/nprogress'

export default {
  data(){
    return {
      model:{
        email:'',
        first_name:'',
        last_name:'',
        contact_no:'',
        contact_type:'home',
        date_of_birth:'',
        gender:null,
        country:'',
        city:'',
        summary:''
      },
      files:[],
      contact_types_option:[
        { value: 'home', text: 'Home' },
        { value: 'work', text: 'Work' },
        { value: 'mobile', text: 'Mobile' }
      ],
      gender_options:[
        { value: null, text: 'Select a Gender' },
        { value: 'male', text: 'Male' },
        { value: 'female', text: 'Female' }
      ],
      errorMessage:'',
      //eslint-disable-next-line
      emailValid: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    }
  },
  props:['data', 'job_id'],
  components:{ DropDown},
  methods:{
    ...mapActions('user', ['prospectStep_1', 'prospectUploadCVs']),
    async validate() {
      if (!this.emailValid.test(this.model.email)) {
        this.errorMessage = 'Please provide a valid email address.'
        return false
      }
      else if (this.model.first_name == '' || this.model.lastname == '' || (this.model.gender == null || this.model.gender == '') || this.model.country == '' || this.model.city == '') {
        this.errorMessage = 'Please fill the required fields.'
        return false
      }else{
        var isValid = false
        let isError = false

        var formData = new FormData();
        if(this.files){
          this.files.forEach((file) => {
            formData.append("files", file);
          });
        }
        formData.append("id", this.model._id);
        formData.append("last_name", this.model.last_name);
        formData.append("first_name", this.model.first_name);
        formData.append("jp_first_name", this.model.jp_first_name);
        formData.append("jp_last_name", this.model.jp_last_name);
        formData.append("summary", this.model.summary);
        formData.append("industry", this.model.industry);
        formData.append("country", this.model.country);
        formData.append("city", this.model.city);
        formData.append("contact_no", this.model.contact_no);
        formData.append("contact_type", this.model.contact_type);
        formData.append("date_of_birth", this.model.date_of_birth);
        formData.append("gender", this.model.gender);
        formData.append("email", this.model.email);
        formData.append("job_id", this.job_id);

        NProgress.start()
        if(this.files.length > 0){
          await this.prospectUploadCVs(formData).then(res => {
            if(res.data.success){
              this.model = res.data.user
              isValid = true
            }else{
              this.errorMessage = res.data.errorMessage
              if(res.data.vincereError){
                isError = true
              }
            }
            NProgress.done()
          }).catch(err => {
            this.errorMessage = err.errorMessage
            NProgress.done()
          })
          this.$emit('on-validate', {user:this.model}, isValid, isError)
          return isValid
        }else{
          this.model.job_id = this.job_id
          this.$emit('final-data', this.model)
          .then(res => {
            if(res.data.success){
              this.model = res.data.user
              isValid = true
            }else{
              this.errorMessage = res.data.errorMessage
              if(res.data.vincereError){
                isError = true
              }
            }
            NProgress.done()
          })
          
          this.$emit('on-validate', {user:this.model}, isValid, isError)
          return isValid
        }
        
      }
    },
    reset(){
      this.model = {
        email:'',
        first_name:'',
        last_name:'',
        contact_no:'',
        contact_type:'home',
        date_of_birth:'',
        gender:null,
        country:'',
        city:'',
        summary:''
      }
      this.errorMessage = '',
      this.files = []
    },
  },
  mounted() {
    /* console.log(this.$parent.$attr)
    console.log(this.$parents)
     */
    /* this.model = this.$props['data'] || {} */
  },
  watch: { 
    data: function(newVal) { // watch it
     this.model = newVal
    }
  }
}
</script>